<div layout="row">
    <ag-grid-angular #theGrid [frameworkComponents]="frameworkComponents" style="width: 100%; height: calc(100vh - 40px - 48px - 48px - 36px - 36px)"
    class="ag-theme-balham-main" [gridOptions]="gridOptions" [columnDefs]="columnDefs" [rowData]="gridData"></ag-grid-angular>
</div>
